

function Footer() {
  return (
    <div className="footer">
      <p>This website was created for educational purposes with Google's YouTube API</p>
    </div>
  )
}

export default Footer
